import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Box } from "@material-ui/core";

const Loading = () => {
  return (
    <Box mt={1} mb={1}>
      <LinearProgress />
    </Box>
  );
};

export default Loading;
